const MOUNT_POINT_ID = 'vm__white-header-dweb';

module.exports = {
  MOUNT_POINT_ID,
};
